import { useEffect, useState } from "react";

const useBrowserWindowActivity = () => {
    const [isBrowserWindowActive, setIsBrowserWindowActive] = useState(true);
    const [isInitialWindowLoad, setIsInitialWindowLoad] = useState<boolean>(true);
  
    useEffect(() => {
      setIsInitialWindowLoad(false);
    }, []);
  
    useEffect(() => {
      const handleActivity = (isActive?: boolean) => {
        if (typeof isActive === "boolean") {
          isActive
            ? !isBrowserWindowActive && setIsBrowserWindowActive(true)
            : isBrowserWindowActive && setIsBrowserWindowActive(false);
        } else {
          document.hidden
            ? isBrowserWindowActive && setIsBrowserWindowActive(false)
            : !isBrowserWindowActive && setIsBrowserWindowActive(true);
        }
      };
  
      window.addEventListener("focus", () => handleActivity(true));
      window.addEventListener("blur", () => handleActivity(false));
      document.addEventListener("visibilitychange", () => handleActivity());
  
      return () => {
        window.addEventListener("focus", () => handleActivity(true));
        window.addEventListener("blur", () => handleActivity(false));
        document.addEventListener("visibilitychange", () => handleActivity());
      };
    }, [isBrowserWindowActive]);
  
    return { isInitialWindowLoad, isBrowserWindowActive };
  };
  
  export default useBrowserWindowActivity;
  